<template>
  <div class="table--wrap" ref="listTable">
    <p class="content__title">{{ $t('plan.period') }}</p>
    <ui-selectbox class="some-class" :value="duration" :items="durationList" :width="'175px'" :hideLabel="true"
      @input="onDurationChange" />
    <app-pagination class="jam-detail-pagination clearfix pagination"
                    :total="usedJamCount"
                    :page="page"
                    :limit="limit"
                    :type="'basketList'"
                    :filterList="filterJamDetailList"
                    :filterPaymentList="filterPaymentList"
                    :dateRange="dateRange"
                    :jamValue="jamValue"
                    @onChangeDate="onChangeDate"
                    @onChangeJamFilter="onChangeJamFilter"
                    @onPagingOptionChange="onPagingOptionChange">
    </app-pagination>
    <data-table :headers="useHeaders" @changeSort="changeSort">
      <template v-slot:colgroup>
        <colgroup>
          <col width="33%">
          <col width="33%">
          <col width="33%">
          <col width="33%">
        </colgroup>
      </template>
      <template v-slot v-if="isLoaded">
        <tbody v-if="usedJamCount">
          <tr v-for="(item, index) in usedJam" :key="index" :class="{'child': item.child, 'on': item.show, 'up': item.chargeShow}">
            <td class="data__date">{{ item.regDate | dashDate }}</td>
            <td v-if="item.jamUseCount > 0" class="data__total" :class="{'child': item.child}">+{{ item.jamUseCount | thousand }}</td>
            <td v-if="item.jamUseCount <= 0" class="data__total" :class="{'child': item.child}">{{ item.jamUseCount | thousand }}</td>
            <td class="data__date_expire expireDate has-detail" :class="{'child': item.child}" v-if="item.child && item.show">
              {{ item.expireDate | dashDate  }}
            </td>
            <td class="data__date_expire expireDate has-detail" :class="{'has-detail': item.detailCount, 'non-detail': !item.detailCount}" v-else>
              {{ item.expireDate | dashDate  }}
              <template v-if="item.detailCount > 1">
                <span class="detail-count"> +{{item.detailCount}}</span>
                <i class="icon icon--toggle-slide16" :class="{'up': item.chargeShow}" @click="toggleCharge(item, $event)" ></i>
              </template>
            </td>
            <td v-if="item.type === stateType.MOVE_TO_BASKET" class="data__total">{{$t('plan.jamState.MOVE_TO_BASKET')}}</td>
            <td v-else-if="item.type === stateType.MOVE_TO_MY_JAM">{{$t('plan.jamState.MOVE_TO_MY_JAM')}}</td>
            <td v-else-if="item.type === stateType.CX_HEATMAP">{{$t('plan.jamState.CX_HEATMAP')}}</td>
            <td v-else-if="item.type === stateType.JAM_EXPIRED">{{$t('plan.jamState.JAM_EXPIRED')}}</td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr>
            <td class="no-list" colspan="4">
              {{ $t('plan.noUsedJam') }}
            </td>
          </tr>
        </tbody>
      </template>
    </data-table>
  </div>
</template>
<script>
import UiSelectbox from '@/components/ui/UiSelectbox'
import AppPagination from '@/components/ui/AppPagination'
import DataTable from '@/components/ui/DataTable'
import { mapState } from 'vuex'
import { parse, startOfDay, addDays, addMonths, format } from 'date-fns'
import {
  JAM_BASKET_LIST_STATE,
  JAM_PAYMENT_LIST_STATE
} from '@/libs/constants'

export default {
  components: {
    AppPagination,
    UiSelectbox,
    DataTable
  },
  props: [
    'usedJam',
    'length',
    'isLoaded',
    'jamValue'
  ],
  data () {
    return {
      stateType: JAM_PAYMENT_LIST_STATE,
      searchParam: Object.values(JAM_BASKET_LIST_STATE),
      duration: 0,
      page: 1,
      limit: 30,
      dateRange: {
        startDate: null,
        endDate: null
      },
      filterJamDetailList: [],
      filterPaymentList: []
    }
  },
  computed: {
    useHeaders () {
      return [
        { name: this.$t('plan.usedJamDate'), sortable: true, value: 'regDate' },
        { name: this.$t('plan.usedJam'), sortable: true, value: 'jamUseCount' },
        { name: this.$t('plan.jamExpiration'), sortable: true, value: 'expireDate' },
        { name: this.$t('plan.jamUseHistory'), sortable: true, value: 'type' }
      ]
    },
    durationList () {
      return [
        { value: 0, text: this.$t('common.all') },
        { value: 3, text: this.$t('common.recentMonths', { month: '3' }) },
        { value: 6, text: this.$t('common.recentMonths', { month: '6' }) },
        { value: 12, text: this.$t('common.recentMonths', { month: '12' }) },
        { value: 24, text: this.$t('common.recentMonths', { month: '24' }) }
      ]
    },
    ...mapState([
      'userData'
    ]),
    selectedJamFilter () {
      const data = []
      this.filterJamDetailList.forEach(item => {
        if (item.key !== 'all' && item.value) {
          data.push(item.key)
        }
      })
      return data
    },
    selectedPaymentFilter () {
      const data = []
      this.filterPaymentList.forEach(item => {
        if (item.key !== 'all' && item.value) {
          data.push(item.key)
        }
      })
      return data
    },
    usedJamCount () {
      return this.length > 0 ? this.length : 0
    },
    currentDate () {
      const today = format(new Date(), 'YYYY-MM-DD')
      return today
    }
  },
  created () {
    const filterJamDetailList = JAM_BASKET_LIST_STATE
    this.filterJamDetailList.push({
      value: true,
      key: 'all',
      type: 'all'
    })
    for (let key in filterJamDetailList) {
      const jamDetail = filterJamDetailList[key]
      const data = {
        value: true,
        key: key,
        type: jamDetail.type
      }
      this.filterJamDetailList.push(data)
    }
  },
  methods: {
    onChangeDate (startDate, endDate) {
      this.dateRange.startDate = startDate
      this.dateRange.endDate = endDate
    },
    onChangeJamFilter (filterJamDetail, filterPayment, dateRange, type = null, jamValue) {
      this.filterJamDetailList = filterJamDetail
      this.filterPaymentList = filterPayment
      this.dateRange = { ...dateRange }
      const paging = {
        page: 1,
        limit: this.limit
      }
      this.page = 1
      this.$emit('setJamList', paging, dateRange, this.sort, this.selectedJamFilter, this.selectedPaymentFilter, this.serviceType, jamValue)
    },
    changeSort (value) {
      const paging = {
        page: this.page,
        limit: this.limit
      }
      this.$emit('setJamList', paging, this.dateRange, value, this.selectedJamFilter, this.selectedPaymentFilter)
    },
    toggleCharge (data, $event) {
      this.$emit('show', data)
    },
    onPagingOptionChange (page, limit) {
      this.page = page
      this.limit = limit
      this.onSetOptionList()
    },
    onDurationChange (duration) {
      const today = startOfDay(new Date())
      const minDate = addDays(startOfDay(parse(this.userData.regDate)), -1)
      const endDate = parse(today)
      let startDate = addMonths(today, -duration)
      if (duration === 0) {
        startDate = addDays(parse(this.userData.regDate), -1)
      }

      if (startDate < minDate) {
        startDate = parse(minDate)
      }

      this.duration = duration
      this.dateRange = {
        startDate: format(startDate, 'YYYY-MM-DD'),
        endDate: format(endDate, 'YYYY-MM-DD')
      }
      this.page = 0
      this.onSetOptionList()
    },
    onSetOptionList () {
      const paging = {
        page: this.page,
        limit: this.limit
      }
      const dateRange = this.dateRange
      this.$emit('setJamList', paging, dateRange, this.sort, this.selectedJamFilter, this.selectedPaymentFilter)
    }
  }
}
</script>
<style lang="scss" scoped="scoped">
.icon--toggle-slide16 {
  top: 3px;
  position: relative;
  margin-left: 5px;
  width: 16px;
  height: 16px;
  background: url(../../../assets/img/icon_slide_toggle_size16.svg) no-repeat 0 0;
  cursor: pointer;
  pointer-events: visible;
  &.up {
    transform: rotate(180deg);
  }
}
.table--wrap {
  .jam-detail-pagination {
    float: right;
    width: auto;
    margin-bottom: 15px;
  }

  .content__title {
    font-size: 15px;
    font-weight: 500;
    color: #2f2f2f;
    display: inline-block;
    padding: 13px 0 20px 0;
    float: left;
  }

  .ui_select {
    float: left;
    margin-left: 20px;
  }

  /deep/ thead {
    font-size: 13px;
  }

  /deep/ tbody tr {
    border-top: 1px solid #ebebeb;
    border-bottom: 1px solid #ebebeb;
    &.child {
      display: none;
      &.on {
        display: table-row;
        border-top: 0px solid #eeeeee;
        border-bottom: none;
        & > td {
          height: 36px;
        }
      }
    }

    &.up {
      border-bottom: none;
    }  }

  /deep/ tbody tr td {
    height: 50px;
    font-size: 13px;
    line-height: 1.23;
    color: #2f2f2f;
    text-align: center;

    .detail-count {
      margin-left: 5px;
      display: inline-block;
      vertical-align: middle;
      background: #F0F0F0;
      border-radius: 10px;
      border: 1px #DDDDDD solid;
      font-size: 12px;
      padding: 4px 6px;
      transform: translateY(-1px);
      line-height: 1;
      color: #666666;
    }
    &.has-detail {
      padding-left: 45px;
    }
    &.non-detail {
      padding-right: 10px;
    }
    &.child {
      color: #FF5B8C;
    }
    &.expireDate {
      text-align: left;
    }
  }

  /deep/ tbody tr .no-list {
    height: 199px;
    color: #767676;
    text-align: center;
  }

  /deep/ thead tr th:nth-child(3) {
    text-align: left;
    padding-left: 45px;
  }
}
</style>
